<template>
  <div class="market-key-stats-element" @click="onClick">
    <div class="market-key-stats-element__title">
      {{ obj.title }}
    </div>
    <div class="market-key-stats-element__wrap market-key-stats-element__wrap--left">
      <div class="market-key-stats-element__center">
        <div class="market-key-stats-element__percent">
          {{ Number(obj.valueA).toFixed(1) }}<span class="market-key-stats-element__sign">%</span>
        </div>
        <div class="market-key-stats-element__delta" v-if="obj.valueAHasTrend">
          <market-change-price :price="obj.valueATrendPercentage" :percent="true" />
        </div>
      </div>
      <div class="market-key-stats-element__sub-title">{{ obj.valueASubtitle }}</div>
    </div>
    <div class="market-key-stats-element__wrap market-key-stats-element__wrap--right">
      <div class="market-key-stats-element__center">
        <div class="market-key-stats-element__percent">
          {{ Number(obj.valueB).toFixed(1) }}<span class="market-key-stats-element__sign">%</span>
        </div>
        <div class="market-key-stats-element__delta" v-if="obj.valueBHasTrend">
          <market-change-price :price="obj.valueBTrendPercentage" :percent="true" />
        </div>
      </div>
      <div class="market-key-stats-element__sub-title">{{ obj.valueBSubtitle }}</div>
    </div>
    <div class="market-key-stats-element__footer">
      <a v-if="obj.urlData" :href="obj.urlData" @click="$event.stopPropagation()" v-outer-link>
        {{ obj.source }}
      </a>
      <a href="#" v-else>
        {{ obj.source }}
      </a>
    </div>
  </div>
</template>

<script src="./market-key-stats-element.js"></script>
<style src="./market-key-stats-element.scss" lang="scss"></style>
